import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/DiscountFilled.tsx
import React from "react";
var SvgDiscountFilled, DiscountFilled_default;
var init_DiscountFilled = __esm({
  "src/icons/DiscountFilled.tsx"() {
    SvgDiscountFilled = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12ZM7.75596 17.567C7.72406 17.7358 7.90585 17.8636 8.05393 17.7765L11.8986 15.5136C11.9612 15.4767 12.0388 15.4767 12.1014 15.5136L15.9461 17.7765C16.0941 17.8636 16.2759 17.7358 16.244 17.567L15.3798 12.9926C15.3673 12.9267 15.3888 12.8589 15.4369 12.8121L18.7014 9.63802C18.8217 9.52108 18.7532 9.31693 18.5867 9.29617L14.1895 8.7478C14.1196 8.73908 14.0594 8.69421 14.0311 8.62969L12.1831 4.41747C12.1132 4.25794 11.8868 4.25794 11.8169 4.41747L9.96889 8.62969C9.94059 8.69421 9.88041 8.73908 9.81049 8.7478L5.41326 9.29617C5.24679 9.31693 5.17831 9.52108 5.29859 9.63802L8.56309 12.8121C8.61121 12.8589 8.63265 12.9267 8.6202 12.9926L7.75596 17.567Z",
          fill: "currentColor"
        }
      )
    );
    DiscountFilled_default = SvgDiscountFilled;
  }
});

export {
  DiscountFilled_default,
  init_DiscountFilled
};
